import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'
import WalletsDirectoryPage from './WalletsDirectoryPage.vue'

export const walletsDirectoryRoutes: RouteRecordRaw[] = [
  {
    path: routes.TREASURY_WALLETS_DIRECTORY,
    name: 'treasury.walletsDirectory',
    component: WalletsDirectoryPage,
    meta: {
      layout: 'admin',
      requiresAuth: true,
      title: 'Investor wallets',
      activeMenu: 'Treasury',
    },
  },
]
